import React from 'react';
import get from 'lodash/get';
import JsxParser from 'react-jsx-parser';

export const isTestEnvironment = process.env.NODE_ENV === 'test';

function validateReceivedMessage(receivedMessage, intlKey, isTestEnv = isTestEnvironment) {
  const receivedMessageIsEqualToIntlKey = receivedMessage === intlKey;
  const isReceveidMessageUndefined = typeof receivedMessage === 'undefined';
  const isInvalidReceivedMessage = receivedMessageIsEqualToIntlKey || isReceveidMessageUndefined;

  if (isInvalidReceivedMessage && !isTestEnv) {
    throw new Error(`It's not possible to found a message for the key "${intlKey}", please check it again

    Aditional info:
    - "receivedMessage": ${receivedMessage}
    - "intlKey": ${intlKey}
    `);
  }
}

export function customFormatMessage({ cmsMessages, formatMessage }, isTestEnv) {
  return (formatMessageArg, formatMessageValues = {}) => {
    const isFromCMS = formatMessageArg.id.includes('cms.');
    const isMessageOptional = formatMessageArg.optional || false;

    if (isFromCMS) {
      const cmsKey = formatMessageArg.id.replace('cms.', '');
      const message = (get(cmsMessages, cmsKey) ?? '') || undefined;
      const hasFormatMessageValues = Object.keys(formatMessageValues).length;

      if (!isMessageOptional) validateReceivedMessage(message, cmsKey, isTestEnv);

      if (hasFormatMessageValues) {
        return (
          <JsxParser
            components={formatMessageValues}
            jsx={message}
          />
        );
      }

      return message;
    }

    const cmsKey = formatMessageArg.id;
    const message = formatMessage(formatMessageArg, formatMessageValues);

    if (!isMessageOptional) validateReceivedMessage(message, cmsKey, isTestEnv);

    return message;
  };
}
